import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { MenuElement, UserData } from '../../interfaces/interfaces';
import { UserService } from '../../services/user.service';
import { AvatarselectorComponent } from '../avatarselector/avatarselector.component';
import { LogoutComponent } from '../logout/logout.component';
import { FrameService } from '../../services/frame.service';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss'],
  providers: [DialogService]
})
export class FrameComponent implements OnInit {

  userData: UserData|null = null;
  avatar = 2;
  menuElements: MenuElement[] = [];
  logoUrl: string = null;

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private router: Router,
    private dialogService: DialogService,
    private frameService: FrameService
  ) {
    this.userData = this.userService.userData;
    this.menuElements = this.frameService.menuElemments.filter((menuElement: MenuElement) => {
      return this.userService.hasPermissions(menuElement.permissions);
    });
    this.logoUrl = this.frameService.logoUrl;
  }

  ngOnInit(): void {
  }

  showLogoutDialog(): void {
    this.dialogService.open(LogoutComponent, {
      width: '500px',
      header: 'Kilépés'
    });
  }

  logout(): void {
    this.apiService.logout().subscribe((rsp) => {
      this.userService.userData = null;
      this.router.navigateByUrl('login');
    });
  }

  showAvatarSelecctorDialog(): void {
    this.dialogService.open(AvatarselectorComponent, {
      width: '500px',
      header: 'Avatar kiválasztása'
    }).onClose.pipe(filter(v => v !== undefined)).subscribe((avatar) => this.avatar = avatar);
  }

}
